var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentTag,{tag:"component",class:_vm.currentClasses,attrs:{"type":_vm.type,"disabled":_vm.disabled,"form":_vm.form},on:{"click":_vm.clickHandler}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('Submit')))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }